// make components that use Translator testable in jsdom

export interface ITranslator {
  trans: (key: string, argumentsObject?: any) => string
  locale: string
}

export default function(): ITranslator {
  // TODO remove false after window.Translator will be defined
  if (
    typeof window === 'object' &&
    window !== null &&
    typeof window['Translator'] !== 'undefined'
  ) {
    return window['Translator'] as ITranslator
  } else {
    return {
      trans: translationKey => translationKey
    } as ITranslator
  }
}
